import * as React from 'react'
import I18n from '../../../../core/i18n'
import { IJsonResponse } from '../../../../core/JsonApiSerializer'
import { adminService } from '../../../../core/services'
import { InputText, ListItem } from '../../../atoms'
import MarkdownEditorWithPreview from '../../../molecules/MarkdownEditorWithPreview'
import AdminLayoutEdit from '../_layouts/edit'
import * as interfaces from '../../../../static/interfaces'

declare var window: interfaces.IWindow

interface IProps {
  page: IJsonResponse
}

const FIELDS = {
  id: 'id',
  path: 'path',
  content: 'content',
}

const title = 'Edit page'

const AdminPageEdit: React.FC<IProps> = props => {
  const { data: page } = adminService.getDataFromJson(props.page)
  const [content, setContent] = React.useState(page.content || '')
  const [previewHtml, setPreviewHtml] = React.useState('')

  React.useEffect(() => {
    const timer = setTimeout(async () => {
      try {
        const { html } = await adminService.previewPage(content)
        setPreviewHtml(html)
      } catch (e) {
        // ignore preview errors (e.g. network)
      }
    }, 500)

    return () => clearTimeout(timer)
  }, [content])

  const handleSubmit = React.useCallback(
    async (initialValues, values) => {
      const { flush } = await adminService.updatePage(page.id, values)
      window.flashMessages.addMessage({ text: flush.message, type: flush.type })
      location.href = '/admin/pages'
    },
    [page.id]
  )

  return (
    <AdminLayoutEdit
      model="pages"
      title={title}
      fields={FIELDS}
      indexLink="/admin/pages"
      formItems={
        <>
          <ListItem>
            <InputText
              readonly={true}
              name="id"
              defaultValue={page.id}
              label={I18n.t('generic.id')}
            />
          </ListItem>
          <ListItem>
            <InputText required={true} name="path" defaultValue={page.path} label="Path" />
          </ListItem>
          <ListItem>
            <MarkdownEditorWithPreview
              required={true}
              name="content"
              label="Content (Markdown)"
              placeholder="# Terms of Service"
              value={content}
              previewHtml={previewHtml}
              onChange={setContent}
            />
          </ListItem>
        </>
      }
      handleSubmit={handleSubmit}
    />
  )
}

export default AdminPageEdit
